'use client'

import { createContext, useContext, type ReactNode } from 'react'
import { useOfflineManager } from '../hooks/useOfflineManager'

// Infer the return type of the hook
type OfflineContextType = ReturnType<typeof useOfflineManager>

const OfflineContext = createContext<OfflineContextType | null>(null)

export function OfflineProvider({ children }: { children: ReactNode }) {
  const offlineState = useOfflineManager()

  return (
    <OfflineContext.Provider value={offlineState}>
      {children}
    </OfflineContext.Provider>
  )
}

export function useOffline() {
  const context = useContext(OfflineContext)
  if (!context) {
    throw new Error('useOffline must be used within an OfflineProvider')
  }
  return context
}
